import { MtTaskComment } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"

// eslint-disable-next-line import/prefer-default-export
export const setTaskCommentList = (taskId: number, comments: MtTaskComment[]) => ({
    type: inferLiteral(types.TASK_COMMENT_LIST),
    taskId,
    comments,
})
